<script>
export default {
    name: 'PollIcon'
};
</script>

<template>
    <path
        d="M5.4046 0.666748C2.51546 0.666748 0.166504 3.01571 0.166504 5.90484V32.0953C0.166504 34.9845 2.51546 37.3334 5.4046 37.3334H31.5951C34.4842 37.3334 36.8332 34.9845 36.8332 32.0953V5.90484C36.8332 3.01571 34.4842 0.666748 31.5951 0.666748H5.4046ZM10.6427 16.381C12.0914 16.381 13.2617 17.5514 13.2617 19.0001V26.8572C13.2617 28.3059 12.0914 29.4763 10.6427 29.4763C9.19403 29.4763 8.02365 28.3059 8.02365 26.8572V19.0001C8.02365 17.5514 9.19403 16.381 10.6427 16.381ZM15.8808 11.1429C15.8808 9.69428 17.0512 8.52389 18.4998 8.52389C19.9485 8.52389 21.1189 9.69428 21.1189 11.1429V26.8572C21.1189 28.3059 19.9485 29.4763 18.4998 29.4763C17.0512 29.4763 15.8808 28.3059 15.8808 26.8572V11.1429ZM26.357 21.6191C27.8056 21.6191 28.976 22.7895 28.976 24.2382V26.8572C28.976 28.3059 27.8056 29.4763 26.357 29.4763C24.9083 29.4763 23.7379 28.3059 23.7379 26.8572V24.2382C23.7379 22.7895 24.9083 21.6191 26.357 21.6191Z"
    />
</template>
